// Ortak modüllerin (SMS, güvenlik) beklediği axios benzeri HTTP istemcisi — fetch üzerinde.
// Çerez + CSRF başlığı + 401'de yenileme utils/apiFetch.js sarmalayıcısından gelir.
// Hata: err.response = { status, data } (modüllerin errorDetails'i bunu okur).
export function createHttp() {
  const call = async (method, url, body, params) => {
    const qs = params
      ? '?' + new URLSearchParams(Object.entries(params).filter(([, v]) => v !== undefined && v !== '')).toString()
      : '';
    const res = await fetch(url + qs, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
    const isJson = (res.headers.get('content-type') || '').includes('application/json');
    const data = isJson ? await res.json().catch(() => ({})) : {};
    // JSON olmayan başarılı yanıt (ör. API'ye ulaşılamayıp SPA sayfası döndü) modüle veri diye gitmesin.
    if (res.ok && !isJson && res.status !== 204) throw Object.assign(new Error('Sunucu beklenmeyen bir yanıt döndürdü.'), { response: { status: res.status, data } });
    if (!res.ok) throw Object.assign(new Error(data.message || data.error || res.statusText), { response: { status: res.status, data } });
    return { data };
  };
  return {
    get:    (url, config) => call('GET', url, undefined, config?.params),
    post:   (url, body) => call('POST', url, body),
    put:    (url, body) => call('PUT', url, body),
    delete: (url) => call('DELETE', url),
  };
}

// Modül hook'ları http nesnesini sabit kabul eder — tek örnek.
export const http = createHttp();
